/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationPasswordResetRequest
 */
export interface AuthenticationPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationPasswordResetRequest
     */
    email: string;
}

export function AuthenticationPasswordResetRequestFromJSON(json: any): AuthenticationPasswordResetRequest {
    return AuthenticationPasswordResetRequestFromJSONTyped(json, false);
}

export function AuthenticationPasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationPasswordResetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function AuthenticationPasswordResetRequestToJSON(value?: AuthenticationPasswordResetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

